const FETCH_SEARCH_SUCCESS = 'BEAMLY/CCX/FETCH_SEARCH_SUCCESS';
const UPDATE_SEARCH = 'BEAMLY/CCX/UPDATE_SEARCH';
const CLEAR_SEARCH = 'BEAMLY/CCX/CLEAR_SEARCH';
const SET_HISTORY = 'BEAMLY/CCX/SET_SEARCH_HISTORY';
const SET_HISTORY_LOADED = 'BEAMLY/CCX/SET_SEARCH_HISTORY_LOADED';

export {
  FETCH_SEARCH_SUCCESS,
  UPDATE_SEARCH,
  CLEAR_SEARCH,
  SET_HISTORY,
  SET_HISTORY_LOADED,
};
